import { render, staticRenderFns } from "./realtime-refresh.vue?vue&type=template&id=76cbe0f4&"
import script from "./realtime-refresh.vue?vue&type=script&lang=ts&"
export * from "./realtime-refresh.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports